import {Injectable} from "@angular/core";
import {GroupService} from "../../services/groupService";
import {Group} from "../../objects/groups/group";
import {BaseResponse} from "../../objects/common/baseResponse";
/**
 * Created by vlad.p on 8/9/2017.
 */

@Injectable()
export class GroupResolver {

    constructor(private groupService: GroupService) {
    }

    public resolve(): Promise<BaseResponse<Group[]>> {

        return this.groupService.getAllGroups();
    }

}


// WEBPACK FOOTER //
// ./app/components/agent/group.resolver.ts